/**
 * 视频轮询页面配置
 */
export default {
  liveStreamRoot: {
    component: 'VmpAirContainer',
    children: [
      'pannelHeaderRight',
      'comStreamList',
      'comThirdStream',
      'comDesktopScreen',
      'comAllDialog'
    ],
    handleClick: [
      {
        cuid: 'comDesktopScreen',
        method: 'showConfirm',
        args: []
      }
    ]
  },
  // 上麦流列表
  comStreamList: {
    component: 'VmpStreamListLive',
    children: ['comStreamLocal', 'comPcPlayerLiveYun', 'comStreamRemote']
  },
  // 本地流
  comStreamLocal: {
    component: 'VmpStreamLocal',
    exchangeCfg: [
      {
        cuid: 'comDocUne',
        kind: 'document'
      },
      {
        cuid: 'comInsertVideoList',
        kind: 'insertMedia'
      }
    ],
    emitClickPublishComplate: [
      {
        cuid: 'pannelHeaderRight',
        method: 'handlePublishComplate'
      }
    ],
    emitClickUnpublishComplate: [
      {
        cuid: 'pannelHeaderRight',
        method: 'handleUnpublishComplate'
      }
    ],
    openCheckMediaDialog: [
      {
        cuid: 'comMediaSetting',
        method: 'showCheck',
        args: ['$0']
      }
    ]
  },
  // 远端流组件
  comStreamRemote: {
    component: 'VmpStreamRemote',
    emitClickStopShare: [
      {
        cuid: 'comDesktopScreen',
        method: 'stopShare',
        args: ['$0']
      }
    ],
    emitClickStopInsert: [
      {
        cuid: 'comInsertStream',
        method: 'closeInsertvideoHandler'
      }
    ]
  },
  // 云导播播放器组件
  comPcPlayerLiveYun: {
    component: 'VmpPcPlayerLiveYun',
    emitClickMediaSetting: {
      cuid: 'comMediaSetting',
      method: 'showMediaSetting'
    }
  },
  comThirdStream: {
    component: 'VmpThirdStream',
    emitClickStartClick: [
      {
        cuid: 'pannelHeaderRight',
        method: 'handleStartClick',
        args: ['$0', '$1']
      }
    ]
  },
  // 顶部右侧容器
  pannelHeaderRight: {
    component: 'VmpHeaderRight',
    emitVirtualClick: [
      {
        cuid: 'comVirtualPeople',
        method: 'openVirtualDialog',
        args: [
          {
            type: 1
          }
        ]
      }
    ],
    emitClickStartLive: [
      {
        cuid: 'comStreamLocal',
        method: 'startPushOnce'
      }
    ],
    emitMediaSettingClick: [
      {
        cuid: 'comMediaSetting',
        method: 'showMediaSetting'
      }
    ],
    emitClickThirdStream: [
      {
        cuid: 'comThirdStream',
        method: 'showThirdStream',
        args: ['$0']
      }
    ],
    emitClickCheckStartPush: [
      {
        cuid: 'comStreamLocal',
        method: 'checkStartPush'
      }
    ],
    emitStartLiveSuccess: [
      {
        cuid: 'comStreamLocal',
        method: 'startLiveSuccess'
      }
    ],
    emitClickCheckValidatePullUrl: [
      {
        cuid: 'comThirdStream',
        method: 'validatePullUrl'
      }
    ],
    emitOpenShare: [
      {
        cuid: 'comShare',
        method: 'openShareDialog'
      }
    ]
  },
  // 媒体设置
  comMediaSetting: {
    component: 'VmpPcMediaSetting',
    saveOptions: [
      {
        cuid: 'comStreamLocal',
        method: 'switchStreamType',
        args: ['$0']
      }
    ],
    changeMediaOption: [
      {
        cuid: 'comPcPlayerLiveYun',
        method: 'switchStreamType',
        args: ['$0']
      }
    ]
  },
  // 媒体检查
  comPcMediaCheck: {
    component: 'VmpPcMediaCheck',
    emitInitLocalStream: [
      {
        cuid: 'comStreamLocal',
        method: 'initLocalStream',
        args: ['$0']
      }
    ],
    emitRecheckMedia: [
      {
        cuid: 'pannelHeaderRight',
        method: 'handleRecheck',
        args: ['$0']
      }
    ]
  },
  // 桌面共享菜单
  comShareDesktopMenu: {
    component: 'VmpIconText',
    options: {
      icon: 'vh-saas-iconfont vh-saas-a-line-Desktopsharing',
      text: 'aside_menu.aside_menu_1002',
      kind: 'desktopShare',
      auth: 'desktop_share'
    },
    handleClick: [
      {
        cuid: 'comDesktopScreen',
        method: 'showConfirm',
        args: []
      }
    ]
  },
  // 桌面共享组件
  comDesktopScreen: {
    component: 'VmpStreamDesktopScreen',
    emitClickEndDemonstrate: [
      {
        cuid: 'comDocUne',
        method: 'handleEndDemonstrate'
      }
    ]
  },
  // 所有弹窗集合
  comAllDialog: {
    component: 'VmpAirContainer',
    children: ['comMediaSetting', 'comPcMediaCheck']
  }
};
